import buttonFormFields from '@/components/sections/form-fields/content/button'
import generalSectionFormFields from '@/components/sections/form-fields/design/section'
import contentBoxFormFields from '@/components/sections/form-fields/layout/category-content-box'
import structureFormFields from '@/components/sections/form-fields/layout/structure'

export const content = {
  title: { label: 'Title', type: 'text' },
  introtext: { label: 'Introtext', type: 'text-editor' },
  images: {
    label: 'Images',
    type: 'repeatable',
    fields: {
      'item-title': {
        label: 'Item title',
        type: 'text',
        hideOnList: true
      },
      'item-image': {
        label: 'Item image',
        type: 'media-manager'
      },
      ...buttonFormFields
    }
  }
}

export const design = {
  ...generalSectionFormFields,
  'title-color': {
    label: 'Title color',
    type: 'text-color',
    category: 'Category text'
  },
  'title-font-weight': {
    label: 'Title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Category text'
  },
  'title-tag': {
    label: 'Title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Category text'
  },
  'introtext-color': {
    label: 'Introtext color',
    type: 'text-color',
    category: 'Category text'
  },
  'item-title-color': {
    label: 'Item title color',
    type: 'text-color',
    category: 'Item text'
  },
  'item-title-font-weight': {
    label: 'Item title font weight',
    type: 'radio',
    options: [
      { value: 'var(--title-font-weight)', text: 'Default' },
      { value: 'lighter', text: 'Light' },
      { value: 'bold', text: 'Bold' }
    ],
    category: 'Item text'
  },
  'item-title-tag': {
    label: 'Item title header type',
    type: 'radio',
    options: [
      { value: 'h1', text: 'Heading 1' },
      { value: 'h2', text: 'Heading 2' },
      { value: 'h3', text: 'Heading 3' },
      { value: 'h4', text: 'Heading 4' },
      { value: 'h5', text: 'Heading 5' },
      { value: 'h6', text: 'Heading 6' }
    ],
    category: 'Item text'
  }
}

export const layout = {
  ...structureFormFields,
  'item-columns': {
    label: 'Maximum items per row',
    type: 'radio',
    options: [
      { value: '1', text: 'One' },
      { value: '2', text: 'Two' },
      { value: '3', text: 'Three' },
      { value: '4', text: 'Four' }
    ],
    category: 'Structure'
  },
  'inner-content-horizontal-alignment': {
    label: 'Image inner content horizontal alignment',
    type: 'radio',
    options: [
      { value: 'start', text: 'Left' },
      { value: 'center', text: 'Center' },
      { value: 'end', text: 'Right' }
    ],
    category: 'Media Images'
  },
  'inner-content-padding': {
    label: 'Image inner content padding',
    type: 'slider',
    min: 10,
    max: 100,
    suffix: 'px',
    category: 'Media Images'
  },
  'item-size': {
    label: 'Item size',
    type: 'radio',
    options: [
      { value: 'default', text: 'Image default' },
      { value: 'aspect-ratio', text: 'Aspect ratio' }
    ],
    category: 'Media Images'
  },
  'item-aspect-ratio': {
    label: 'Item aspect ratio',
    type: 'radio',
    options: [
      { value: '1', text: 'Square' },
      { value: '1.33', text: 'Landscape' },
      { value: '1.78', text: 'Wide' },
      { value: '0.8', text: 'Portrait' }
    ],
    showOn: {
      field: 'item-size',
      operator: '==',
      value: 'aspect-ratio'
    },
    category: 'Media Images'
  },
  'content-no-gutters': {
    label: 'Remove space between items',
    type: 'toggle',
    category: 'Media Images'
  },
  ...contentBoxFormFields
}

export const advanced = {}

export default {
  content,
  design,
  layout,
  advanced
}
